// auto-generated by scripts/version-info.js - do not edit, do not commit
export const versionInfo = {
  version: '1.2.3-rc',
  buildTime: '2026-10-06T22:43:35.754Z',
  timestamp: '1791326615754',
  tag: ''
};
